// extracted by mini-css-extract-plugin
export default {"BillDetailView":"BillDetailView_BillDetailView__a1k4Z","BillDetailTable":"BillDetailView_BillDetailTable__Scvyh"};